<template>
    <div class="card">
        <div class="card-header bg-info mb-0">
            <h3 class="my-0">Bandeja de descargas</h3>
        </div>
        <div class="card-body mt-0">
            <div class="table-responsive">
                <table class="table" v-loading="loading">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Formato</th>
                            <th>Fecha generación</th>
                            <th>Fecha proceso completado</th>
                            <th>Estado</th>
                            <th>Tipo</th>
                            <th>Descarga</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="!documents.length">
                            <tr>
                                <td colspan="7">
                                    No hay registros
                                </td>
                            </tr>
                        </template>
                        <template v-else>
                            <tr v-for="(item, index) in documents">
                                <td>{{ recalculateIndex(index) }}</td>
                                <td>{{ item.format }}</td>
                                <td>{{ item.date_init }}</td>
                                <td>{{ item.date_end }}</td>
                                <td>{{ item.status }}</td>
                                <td>{{ item.type }}</td>
                                <td>
                                    <el-button
                                        v-if="item.filename"
                                        @click="clickDownload(item.id)"
                                    >
                                        <i class="fa fa-file-excel" />
                                        Descargar archivo
                                    </el-button>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
                <div>
                    <el-pagination
                        :total="pagination.total"
                        :current-page="pagination.current_page"
                        :page-size="pagination.per_page"
                        @current-change="getRecords"
                        layout="total, prev, pager, next"
                    ></el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            resource: 'report-download-inbox',
            documents: [],
            pagination: {
                total: 0,
                current_page: 1,
                per_page: 0
            },
            loading: false
        }
    },

    async created() {
        await this.getRecords(1)
    },

    methods: {
        async getRecords(page = 1) {
            try {
                this.loading = true
                this.pagination.current_page = page
                const response = await this.$http.get(`${this.resource}/records`, {
                    params: { page }
                })
                const { data } = response
                if (data.success) {
                    this.documents = data.records.data

                    this.pagination.total = data.records.total
                    this.pagination.current_page = data.records.current_page
                    this.pagination.per_page = data.records.per_page
                } else {
                    this.documents = []
                }
            } catch (error) {
                console.log(error)
            } finally {
                this.loading = false
            }
        },

        recalculateIndex(index) {
            return  (this.pagination.per_page * (this.pagination.current_page - 1))
                + index
                + 1
        },

        clickDownload(id) {
            window.open(`${this.resource}/download/${id}`, '_blank')
        }
    }
}
</script>


// WEBPACK FOOTER //
// modules/Report/Resources/assets/js/views/system/report_download_inbox/index.vue